import { formatPercentageInputValue, percentageMask } from "../../utils/admin-utils";
import { buildSegmentationOptions } from "../../utils/segmentation-utils";

export const netSalesFormConfig = ({
	netSales,
	segmentations = [],
	loadingSegmentations = false,
	isEditing = false
} = {}) => {
	const segmentationOptions = buildSegmentationOptions(segmentations);

	return [
		{
			fields: [
				{
					name: "segmentation",
					label: "Tamanho do cliente *",
					type: "select",
					placeholder: loadingSegmentations ? "Carregando..." : "Selecione",
					options: segmentationOptions,
					defaultValue:
						netSales?.idSegmentation !== undefined && netSales?.idSegmentation !== null
							? String(netSales.idSegmentation)
							: "",
					disabled: loadingSegmentations || isEditing,
					columns: 12
				},
				{
					name: "growth",
					label: "% Meta de crescimento acima de *",
					type: "text",
					placeholder: "0",
					defaultValue: formatPercentageInputValue(netSales?.growth),
					columns: 12,
					onChange: percentageMask
				},
				{
					name: "discount",
					label: "% Desconto *",
					type: "text",
					placeholder: "0",
					defaultValue: formatPercentageInputValue(netSales?.discount),
                    columns: 12,
                    onChange: percentageMask
				}
			]
		}
	];
};